



































import { Component, Vue, Prop } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import formatNumber from '@/shared/filters/format-number';
import { PayServiceModel } from '@/models/payservice'
import { APP_CONFIG } from '@/config/app-config';
import payserviceServices from '@/services/payservice-services';
import authService from '@/services/auth-services';

@Component({
    components: {
        ConfirmModal,
        Loading
    }
})
export default class PayServiceDetailFooter extends Vue {
    @Prop({default: null})
    private payservice!: PayServiceModel;
    @Prop({default: {}})
    private customerInfo: any;

    private eventEmit = {
        eventCancelOrder: 'eventCancelOrder',
        eventPayOrder: 'eventPayOrder',
        eventReOrder: 'eventReOrder'
    };
    private actions = {
        cancel: 'cancel',
        payment: 'payment',
        reorder: 'reorder'
    };
    private actionSelected: any = this.actions.cancel;
    private isConfirm = false;
    private showNextConfirm = true;
    private isLoading = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async onActionStatus(action: any) {
        this.actionSelected = action;
        switch(this.actionSelected) {
            case this.actions.cancel: {
                this.modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
            case this.actions.payment: {
                this.modalContent = `<div style="color: #111">Số tiền bạn cần thanh toán là <label class="fb text-danger">${ formatNumber(this.payservice.totalAmount, '0,0') } vnđ.</label>
                                    <div>Bạn có muốn thanh toán không?</div></div>`;
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
            case this.actions.reorder: {
                this.modalContent = 'Bạn có thực sự muốn đặt lại đơn hàng này không?';
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK' && this.actionSelected === this.actions.cancel) {
            this.onCancelOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.payment) {
            this.onPayOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.reorder) {
            this.onReOrder();
        }
    }

    private async onCancelOrder() {
        this.isLoading = true;
        const dataRequest =  {
            Status: 1
        };
        const result = await payserviceServices.updateDetail(this.payservice.id || 0, dataRequest);
        
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Hủy đơn hàng thành công!',
            });
            this.$emit(this.eventEmit.eventCancelOrder, { status: 1 });
            this.isLoading = false;
        }
    }

    private async onPayOrder() {
        if (this.customerInfo.Wallet >= (this.payservice.totalAmount || 0) && this.customerInfo.Wallet > 0) {
            this.isLoading = true;

            const dataRequest = {
                Status: 4,
                Payment: this.payservice.totalAmount
            };
            const result = await payserviceServices.updateDetail(this.payservice.id || 0, dataRequest);
            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Thanh toán thành công!',
                });
                this.$emit(this.eventEmit.eventPayOrder, { status: 4 });
                this.isLoading = false;

                this.getCustomersInfo();
            }
            else {
                this.isLoading = false;
                const error = result.data.error ?result.data.error : `Có lỗi khi cập nhật hệ thống!`;
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: error,
                });
            }
        } else {
            this.modalContent = '<div style="color: #111;">Số tiền trong ví của bạn không đủ để thanh toán.</div><div class="text-danger">Hãy nạp tiền để tiếp tục thanh toán!</div>';
            this.isConfirm = true;
            this.showNextConfirm = false;
        }
        
    }

    private async onReOrder() {
        this.isLoading = true;

        const dataRequest = {
            Status: 2,
            Payment: 0
        };
        const result = await payserviceServices.updateDetail(this.payservice.id || 0, dataRequest);
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Đặt lại đơn hàng thành công!',
            });
            this.$emit(this.eventEmit.eventReOrder, { status: 2 });
        }
        this.isLoading = false;
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }
}
